import * as React from 'react';

const HorizontalDots24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M20.25 10a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M12 10a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-6.5 1.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
  }
));
HorizontalDots24.Size = 24;
HorizontalDots24.Title = "HorizontalDots";

export { HorizontalDots24 as default };
